import { render, staticRenderFns } from "./DebtorsList.vue?vue&type=template&id=70ecd3fb&scoped=true&"
import script from "./DebtorsList.vue?vue&type=script&lang=js&"
export * from "./DebtorsList.vue?vue&type=script&lang=js&"
import style0 from "./DebtorsList.vue?vue&type=style&index=0&id=70ecd3fb&lang=scss&scoped=true&"
import style1 from "./DebtorsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ecd3fb",
  null
  
)

export default component.exports